export default {"src":"/_next/static/media/shadowGroup.750dfba6.svg","height":108,"width":12};